export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.user-details', {
      url: 'my-profile',
      template: '<nets-user-details></nets-user-details>',
    });
};
